import { Boxes, Tag, ShoppingCart, Factory, Truck, Wallet, Leaf, Crown } from "lucide-react";
import { useLanguage } from "@/i18n/LanguageContext";
import { Reveal } from "@/components/Reveal";

const icons = [Boxes, Tag, ShoppingCart, Factory, Truck, Wallet, Leaf, Crown];

export const Audience = () => {
  const { t } = useLanguage();
  const a = t.audience;

  return (
    <section id="audience" className="relative py-24 md:py-32 bg-[#010E3A] border-y border-white/5">
      <div className="container-page">
        <Reveal className="max-w-3xl">
          <span className="overline text-[#CEA26B]">{a.overline}</span>
          <h2 className="mt-4 font-display font-bold tracking-tight text-white text-3xl sm:text-4xl lg:text-5xl leading-tight">
            {a.title}
          </h2>
          <p className="mt-5 text-base md:text-lg text-slate-400 leading-relaxed">{a.subtitle}</p>
        </Reveal>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5">
          {a.items.map((item, i) => {
            const Icon = icons[i] || Boxes;
            return (
              <Reveal key={i} delay={0.05 * i}>
                <div
                  data-testid={`audience-card-${i}`}
                  className="group h-full bg-white/[0.02] border border-white/10 p-7 hover:bg-white/[0.05] hover:-translate-y-1 hover:border-[#CEA26B]/40 transition-all duration-300"
                >
                  <div className="flex items-center justify-center h-12 w-12 border border-white/10 bg-[#CEA26B]/10 group-hover:bg-[#CEA26B]/20 transition-colors">
                    <Icon className="h-6 w-6 text-[#CEA26B]" />
                  </div>
                  <h3 className="mt-6 font-display font-bold text-white text-lg">{item.title}</h3>
                  <p className="mt-2 text-sm text-slate-400 leading-relaxed">{item.desc}</p>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};
